// extracted by mini-css-extract-plugin
module.exports = {"banner":"bannerSingle_banner__kN2kr","wrapper":"bannerSingle_wrapper__xyQZd"};